export const aboutIntro = [
  "瓜田雷达是一个专注于网络热点事件进展追踪的内容站。我们不生产爆料，也不参与评判，只做一件被反复忽略却很费时间的事——把一件事从头到尾捋顺。",
  "网络事件的传播往往是碎片的：今天一条截图，明天一段声明，后天又出现新的说法。普通读者要在不同平台之间跳转、比对时间、分辨前后，成本很高，也很容易只记住最热闹的那一段。我们把零散的信息重新按时间排列，补上背景和出处，让「到底发生了什么」变成可以顺着读下去的东西。",
];

export const aboutPositioning = [
  {
    title: "只追踪，不定性",
    desc: "平台的角色是记录者。我们呈现时间线、标注出处、区分已证实与未证实，但不为任何一方下结论。",
    icon: "ri-scales-3-line",
  },
  {
    title: "顺序比观点重要",
    desc: "很多争议其实源于信息出现的先后被忽略了。把顺序摆正，讨论自然会回到事实上。",
    icon: "ri-sort-asc",
  },
  {
    title: "热度不等于份量",
    desc: "我们用热度值帮助排序，但也会明确提示：讨论规模大，不代表这件事就更值得被认真对待。",
    icon: "ri-bar-chart-2-line",
  },
  {
    title: "可回看，可对照",
    desc: "事件热度过去之后，档案仍然保留。你可以随时回看它的完整脉络，而不是只能找回最后一条热搜。",
    icon: "ri-archive-2-line",
  },
];

export const aboutPrinciples = [
  "信息来源必须可追溯：无法说明出处的说法不进入时间线。",
  "已证实与未证实分开标注：不把传闻写成事实。",
  "矛盾信息并列呈现：不替读者筛选，只提示分歧点在哪里。",
  "更正公开可见：修正内容保留记录，不悄悄替换原文。",
  "不以话题热度作为内容标准：冷门但完整的事件同样值得归档。",
  "不展示与事件无关的个人信息：聚焦事件，不聚焦人。",
];

export const aboutMilestones = [
  {
    year: "2019",
    title: "从一个热点整理文档开始",
    desc: "最初只是几位内容编辑用共享文档手动梳理事件的来龙去脉，供内部讨论使用。",
  },
  {
    year: "2021",
    title: "形成时间线规范",
    desc: "确定「节点必须有出处、状态必须标注」的写作规范，档案开始对外公开可读。",
  },
  {
    year: "2023",
    title: "上线热度与状态体系",
    desc: "引入统一的热度取值与五种状态标签，让不同事件之间可以横向比较。",
  },
  {
    year: "2025",
    title: "开放分类与搜索",
    desc: "将长期归档的事件按领域分类，支持关键词检索，方便读者按兴趣持续跟进。",
  },
  {
    year: "2026",
    title: "事件档案超过一千二百条节点",
    desc: "累计整理的进展节点突破一千二百条，覆盖娱乐、品牌、科技与生活多个领域。",
  },
];

export const aboutTestimonials = [
  {
    quote: "以前追一件事得把几个平台都翻一遍，现在直接看时间线就够了，省下的是找信息的时间。",
    name: "林予",
    role: "内容从业者",
  },
  {
    quote: "最有用的是状态标签，一眼就知道这件事有没有结论，不用点进去才发现还在传。",
    name: "周可",
    role: "长期读者",
  },
  {
    quote: "它不站队，只列顺序和出处，这种克制的写法在现在挺难得的。",
    name: "陈叙",
    role: "媒体观察爱好者",
  },
  {
    quote: "很多事件热度过去就查不到了，这里的档案能一直回看，做行业复盘很方便。",
    name: "何一诺",
    role: "品牌公关从业者",
  },
];

export const aboutContact = {
  email: "hello@guatianradar.com",
  correctionEmail: "correction@guatianradar.com",
  partnershipEmail: "partner@guatianradar.com",
  hours: "工作日 10:00 - 19:00 处理来信",
};